export class Action {

	get import() {
		return import(/* webpackChunkName: "generic-overlay" */ 'modules/generic/overlay/actions/Initialize');
	}

	run() {
		this.context.on('overlay:create', async ({data}) => {
			const
				{Action: Initialize} = await this.import
			;

			this.context.actions
				.add(this.event.type, Initialize)
				.remove(this.event.type, this.constructor);

			this.context.off('overlay:create');

			// eslint-disable-next-line one-var
			const initialize = new Initialize();
			initialize.context = this.context;
			initialize.event = this.event;
			initialize.run();

			this.context.trigger('overlay:create', data);
		});
	}

}
